import React from 'react';
import { config } from '../../../config';
import { __ } from '../../../helpers/TranslationService';

export const ContactHeader = (props: any) => {
    const backgroundImage = `url("${config.images}/common/contactPageHeader.jpg")`;
    const backgroundSize = 'cover'; // Static rule in css is not working
    return (
        <div className="contactHeader" style={{ backgroundImage, backgroundSize }}>
            <h1>{__('CHOOSE YOUR CRUISE EXPERTS', 'dreamlines')}</h1>
            <h3 className="contactSubtitle">
                {__('contactpage_mobilesite_subtext', 'dreamlines')}
            </h3>
        </div>
    );
};
